import React, { PureComponent } from 'react'

import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Form, { FormConsumer } from '@active/react-ui/Form'
import RadioGroup from '@active/react-ui/RadioGroup'
import Radio from '@active/react-ui/Radio'
import { Locale, withI18n } from '@active/react-utils/i18n'
import Popover from '@active/react-ui/Popover'
import noop from 'lodash/noop'

import { ECheckFields, EUDDFields } from './components'
import { newECPType } from '../types'
import { encryptEcheck, encryptEUDD } from '../utils/encrypt'
import './NewECheckEUDD.scss'

export class NewECheckEUDD extends PureComponent {
  static propTypes = newECPType

  static defaultProps = {
    submitTrigger: noop,
  }

  submitFormTrigger = noop

  submitEcheckFieldsForm = noop

  submitEUDDFieldsForm = noop

  constructor(props) {
    super(props)
    this.state = {
      fields: {
        paymentType: 'ECHECK',
        accountType: 'CONSUMER_CHECKING',
      },
    }
  }

  componentDidMount() {
    const { submitTrigger } = this.props
    submitTrigger(this.submitFieldsForm)
  }

  submitFieldsForm = () => {
    const { fields } = this.state
    if (fields.paymentType === 'ECHECK') {
      this.submitEcheckFieldsForm()
    } else {
      this.submitEUDDFieldsForm()
    }
  }

  handleSubmit = () => {
    const { fields } = this.state
    const {
      bankRoutingNumber, accountNumber, accountName, accountType, bicCode, iban,
    } = fields
    const {
      modulus, exponent,
      address, getNewECheckEUDDCallback,
    } = this.props

    const { fields: { paymentType } } = this.state
    const bankCountryCode = iban && iban.substring(0, 2)
    const cipherText = paymentType === 'ECHECK' ? encryptEcheck({
      modulus,
      exponent,
      bankRoutingNumber: bankRoutingNumber && bankRoutingNumber.trim(),
      accountNumber: accountNumber && accountNumber.trim().toUpperCase(),
      accountName: accountName && accountName.trim(),
      accountType,
      postalCode: address && address.postalCode,
      stateProvince: address && address.stateProvince,
    })
      : encryptEUDD({
        modulus,
        exponent,
        bankCountryCode,
        bicCode: bicCode && bicCode.trim(),
        iban: iban && iban.trim(),
        accountName: accountName && accountName.trim(),
        postalCode: address && address.postalCode,
      })
    const commonParams = {
      cipherText,
      modulus,
      accountName,
      paymentType,
    }
    const params = paymentType === 'ECHECK' ? ({
      ...commonParams,
      bankRoutingNumber,
      last2Digits: accountNumber && accountNumber.trim().substring(accountNumber.length - 2).toUpperCase(),
      accountType,
    }) : ({
      ...commonParams,
      last2Digits: iban && iban.trim().substring(iban.length - 2),
      bicCode,
    })
    getNewECheckEUDDCallback(params)
  }

  handleSubmitFailed = () => {
    const { getNewECheckEUDDCallback } = this.props
    getNewECheckEUDDCallback({ errorCode: 'INVALID_PARAMS' })
  }

  handleTypeChange = ({ target: { defaultValue: paymentType } }) => {
    const { fields: { accountType } } = this.state
    this.setState({ fields: { accountType, paymentType } })
  }

  handleFieldsChange = values => {
    this.setState(prvState => ({ fields: { ...prvState.fields, ...values } }))
    this.submitFormTrigger()
  }

  render() {
    const { fields } = this.state
    const { i18n } = this.props
    const euddInfo = Locale({ id: 'passport.lib.components.payment.eudd.hint' })

    return (
      <div className="checkout-payments checkout__new-ecpeudd">
        <h2 className="checkout-payments__title checkout__new-ecpeudd__title">
          <Locale id="passport.lib.components.payment.ecpeudd.title" />
        </h2>
        <Form
          initialValues={fields}
          onSubmit={this.handleSubmit}
          horizontal
          onError={this.handleSubmitFailed}
          onInvalid={this.handleSubmitFailed}
        >
          <FormGroup name="paymentType" required className="payment-type">
            <FormLabel verticalStart><Locale id="passport.lib.components.payment.ecpeudd.type" /></FormLabel>
            <FormField as={RadioGroup} verticalStart defaultValue="CONSUMER_CHECKING" onChange={this.handleTypeChange}>
              <Radio value="ECHECK"><Locale id="passport.lib.components.payment.echeck.label" /></Radio>
              <Radio value="EUDD" aria-labelledby="eudd-label">
                <span id="eudd-label"><Locale id="passport.lib.components.payment.eudd.label" /></span>
                <Popover content={euddInfo} style={{ zIndex: 10 }} placement="top-start" theme="dark">
                  <i role="region" tabIndex={0} aria-label={i18n('passport.lib.components.payment.eudd.hint')} className="ic-question-r question-icon" />
                </Popover>
              </Radio>
            </FormField>
          </FormGroup>
          { fields.paymentType === 'ECHECK'
            ? (
              <ECheckFields
                name="details"
                fields={fields}
                fieldsChangeCallBack={this.handleFieldsChange}
                submitFieldsTrigger={submitFunc => {
                  this.submitEcheckFieldsForm = submitFunc
                }}
              />
            )
            : (
              <EUDDFields
                name="details"
                fields={fields}
                fieldsChangeCallBack={this.handleFieldsChange}
                submitFieldsTrigger={submitFunc => {
                  this.submitEUDDFieldsForm = submitFunc
                }}
              />
            )}
          <FormConsumer>
            {({ form }) => {
              this.submitFormTrigger = form.submitForm
              return null
            }}
          </FormConsumer>
        </Form>
      </div>
    )
  }
}

export default withI18n(NewECheckEUDD)
